export default "__VITE_ASSET__cD2rDjch__"